// extracted by mini-css-extract-plugin
module.exports = {"toggleItemUnselected":"ToggleItem_toggleItemUnselected__1UcHd","text":"ToggleItem_text__1Awdj","toggleItemSelected":"ToggleItem_toggleItemSelected__RQGkv"};